import { motion } from "framer-motion";

import { TertiaryButton } from "@shared/buttons";

interface Props {
  onConfirmClear: () => void;
  onCancelClear: () => void;
}

export const FormulaConfirmClear = ({
  onConfirmClear,
  onCancelClear,
}: Props) => {
  return (
    <motion.div
      className="border border-mars+1 bg-mars-2 rounded-md h-36 p-3 text-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeIn" }}
    >
      <div>Clear formula?</div>
      <TertiaryButton
        className="text-mars hover:bg-white mt-2"
        onClick={onConfirmClear}
      >
        YES, CLEAR
      </TertiaryButton>
      <TertiaryButton className="hover:bg-white" onClick={onCancelClear}>
        CANCEL
      </TertiaryButton>
    </motion.div>
  );
};
